import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=06486cf8&scoped=true&"
import script from "./personalData.vue?vue&type=script&lang=js&"
export * from "./personalData.vue?vue&type=script&lang=js&"
import style0 from "./personalData.vue?vue&type=style&index=0&id=06486cf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06486cf8",
  null
  
)

export default component.exports